<template>
  <div class="layout"
    @click="changeNum++">
    <navBar></navBar>
    <router-view></router-view>

    <sideBar :changeNum="changeNum"></sideBar>
  </div>
</template>

<script>
import navBar from '@/components/navBar.vue'
import sideBar from '@/components/sideBar'
export default {
  name: '',
  props: {},
  components: {
    navBar,
    sideBar
  },
  data() {
    return {
      changeNum: 0
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="scss">
.layout {
  padding-top: 80px;
  height: 100%;
}
@media screen and (max-width: 768px) {
  .layout {
    padding-top: 6rem;
  }
}
</style>
